import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import Currency from './Currency'
import Unavailable from 'Catalog/Availability/Unavailable'

const convertMoney = (value) => {
  return value.toLocaleString('pt-br', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })
}
const getCashbackValue = (cashbackRule, price) => {
  switch (cashbackRule) {
    case '1': return Math.floor(0.05 * price)
    case '2': return Math.round(price)
    case '3': return Math.round(2 * price)
    default: return 0
  }
}
const DisplayCash = ({ price, hasCashBack, currency, ruleCashBack }) => price ? (
  <Fragment>
    <div className='card-price-points col-12 txt-title txt-font-body-bold txt-left color-ui-1 nowrap' title={'R$ ' + convertMoney(price)}>
      {'R$ ' + convertMoney(price)}
    </div>
    {hasCashBack && (
      <div className='card-price-cashback col-auto mx-1 txt-body-sm txt-font-body txt-left txt-bold color-success border border-color-ui-4 radius py-half'>
        <div className='row'>
          <div className='col-auto px-0 d-none d-lg-block'>
            <i className='icon_cashback icon-sm icon icon_gift color-success' />
          </div>
          <div className='col-auto txt-body-sm'>
            Ganhe <Currency value={getCashbackValue(ruleCashBack, price)} {...currency} />
          </div>
        </div>
      </div>
    )}
  </Fragment>
) : <Unavailable />

DisplayCash.propTypes = {
  price: PropTypes.number,
  hasCashBack: PropTypes.bool,
  ruleCashBack: PropTypes.string,
  currency: PropTypes.shape({
    decimalPlaces: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired
  }).isRequired
}

export default DisplayCash



// WEBPACK FOOTER //
// ./src/Catalog/Availability/PriceLabel/DisplayCash.js